// import React from 'react';
import ReactDOM from 'react-dom';
import Cookies from 'js-cookie';
import './index.css';
import App from './App';
import Login from './views/login'
//import Login from './views/Login'
//import Home from './views/home'
import Sitelogin from './views/siteLogin'
import ExtLogin from './views/extLogin'
import reportWebVitals from './reportWebVitals';
// import { browserHistory } from 'react-router'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import 'antd/dist/antd.css';
import store from "./store"
import { Provider } from "react-redux"
import bootstrap from './bootstrap'
import "./assets/style/global.less"
import DdLogin from './views/ddLogin';
import FcDdLogin from './views/fcDdLogin';
import WxLogin from './views/wxLogin';
// import  setUp from './registerMicroApp'
bootstrap().then(() => {
  ReactDOM.render(
    // component={App}
    <Provider store={store}>
     <Router>
       <Switch>
          <Route exact path="/" render = {() => {
            return Cookies.get('token') ? <App/> : <Login/>
          }}/>
          <Route exact path="/home" render = {() => {
            return Cookies.get('token') ? <Login/> : <Login/>
          }}/>
          <Route exact path="/ddLogin" render = {() => {
            return <DdLogin />
          }}/>
          <Route exact path="/fcDdLogin" render = {() => {
            return <FcDdLogin />; 
          }}/>
          <Route exact path="/wxLogin" render = {() => {
            return <WxLogin />; 
          }}/>
          <Route path="/Login" render={() => {
              return Cookies.get('token') ? <Redirect to="/" /> : <Login /> //判断有没有token 有就跳回首页
          }} />
          <Route path="/site-login" render={() => {
              return Cookies.get('token') ? <Redirect to="/" /> : <Sitelogin /> //判断有没有token 有就跳回首页
          }} />
          <Route path="/login" render={() => {
              return Cookies.get('token') ? <Redirect to="/" /> : <Login /> //判断有没有token 有就跳回首页
          }} />
          <Route path="/ext-login" render={() => {
              return Cookies.get('token') ? <Redirect to="/" /> : <ExtLogin /> //判断有没有token 有就跳回首页
          }} />
          <Route path="*" render={() => {
              return Cookies.get('token') ? <App /> : <Login /> //判断有没有token 有就跳回首页
          }} />
       </Switch>
    </Router>
    </Provider>,
    document.getElementById('root')
  );
  // setUp()
})
reportWebVitals();
